import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Tag, Heading } from "@/components/Reveal";
import { getConsent, setConsent } from "@/lib/pixel";
import { useState } from "react";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "$5K Kitchen Offer", to: "/offer", accent: true },
];

const SECTIONS = [
  { h: "What we collect", p: "When you submit a quote or estimate form we store the details you provide (name, email, phone, project details and any photos you upload) so we can contact you about your project. This information is stored on our servers and emailed to our team. We do not sell it." },
  { h: "Meta Pixel", p: "With your consent, this site uses the Meta (Facebook) Pixel to measure page views and completed quote requests so we can understand how people find us and improve our advertising. We do not send your name, contact details, form text or photos to Meta, and advanced matching is turned off. Meta may set cookies and process your IP address and browser information under its own data policy." },
  { h: "Your choices", p: "You can accept or decline measurement cookies using the banner on your first visit, and change your mind at any time using the control below. Declining does not affect your ability to request a quote." },
  { h: "Contact", p: "Questions about privacy? Call (302) 230-1988 or email TBlyden@ConstructionAllianceCo.com." },
];

export default function PrivacyPage() {
  const [consent, setLocal] = useState(getConsent());
  const update = (v) => { setConsent(v); setLocal(v); };

  return (
    <div data-testid="privacy-page">
      <Nav links={LINKS} cta={{ label: "Request free estimate", short: "Free estimate", target: "#", testId: "nav-privacy-cta" }} />
      <main className="pt-32 sm:pt-40 pb-24 lg:pb-40">
        <div className="mx-auto max-w-[1600px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Tag>Privacy notice</Tag>
            <Heading className="mt-6">Your information, plainly explained.</Heading>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.16em] text-ink/50">Last updated June 2026</p>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 divide-y divide-ink/10 border-y border-ink/10">
            {SECTIONS.map((s) => (
              <div key={s.h} className="py-8">
                <h2 className="font-display font-medium text-2xl tracking-[-0.015em] text-ink">{s.h}</h2>
                <p className="mt-3 text-base text-ink/70 leading-relaxed">{s.p}</p>
              </div>
            ))}
            <div className="py-8" data-testid="privacy-consent-controls">
              <h2 className="font-display font-medium text-2xl tracking-[-0.015em] text-ink">Measurement cookies</h2>
              <p className="mt-3 text-base text-ink/70">Current setting: <span className="font-semibold text-ink" data-testid="privacy-consent-status">{consent === "granted" ? "Accepted" : consent === "denied" ? "Declined" : "Not set"}</span></p>
              <div className="mt-4 flex gap-2">
                <button onClick={() => update("granted")} data-testid="privacy-consent-accept" className="bg-ink text-bone font-display font-medium text-sm px-5 py-3 hover:bg-teal transition-colors">Accept</button>
                <button onClick={() => update("denied")} data-testid="privacy-consent-decline" className="border border-ink/25 text-ink font-display font-medium text-sm px-5 py-3 hover:border-ink transition-colors">Decline</button>
              </div>
              {consent === "granted" && <p className="mt-3 text-xs text-ink/50">Declining stops new events immediately; cookies already set by Meta expire on their own schedule or can be cleared in your browser.</p>}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
